<template>
    <div ref="$loader" class="elle-global-loader" />
</template>

<script setup lang="ts">
const { $gsap: gsap } = useNuxtApp();

const $loader = ref<HTMLDivElement | null | undefined>(null);

const loadComplete = useGlobalLoaded();
const pageBeforeComplete = usePageBeforeComplete();
const pageComplete = usePageComplete();

const isMounted = ref<boolean>(false);

onMounted(() => (isMounted.value = true));

watch(
    () => loadComplete.value && isMounted.value,
    state => {
        if (state) {
            const lCol = document.querySelector('.elle-header .l-col');
            const mCol = document.querySelector('.elle-header .m-col');
            const rCol = document.querySelector('.elle-header .r-col');

            gsap.set(lCol, { opacity: 0, alpha: 1 });
            gsap.set(mCol, { opacity: 0, alpha: 1 });
            gsap.set(rCol, { opacity: 0, alpha: 1 });

            const timeline = gsap.timeline({
                paused: true,
                delay: 0,
                onComplete: () => {
                    nextTick(() => {
                        pageBeforeComplete.value = true;
                        pageComplete.value = true;
                    });
                }
            });

            gsap.to($loader.value!, {
                opacity: 0,
                alpha: 0,
                duration: 0.4,
                pointerEvents: 'none',
                ease: 'power2.in'
            });

            timeline.to(lCol, { opacity: 1, alpha: 1, duration: 0.28, ease: 'sine' });
            timeline.to(rCol, { opacity: 1, alpha: 1, duration: 0.28, ease: 'sine' }, '<0.22');
            timeline.to(mCol, { delay: 0.12, opacity: 1, alpha: 1, duration: 0.28, ease: 'sine' });

            timeline.play();
        }
    }
);
</script>
